exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".marginAuto {\r\n    margin: auto;\r\n}\r\n\r\n.displayInlineFlex{\r\n    display: -ms-inline-flexbox;\r\n    display: inline-flex;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/utils/item-type-manager/forms/documents-form/documents-form.component.css
// module id = ../../../../../src/app/components/utils/item-type-manager/forms/documents-form/documents-form.component.css
// module chunks = main